import { OverlayPanel } from 'primereact/overlaypanel';
import React, { useRef } from 'react';

import { useMindmap } from '../../../../pages/mindmap/use-mindmap';
import { ColorPicker, TextColors } from '../../../ui/color-picker/color-picker';

export const FormatTextContentMenuColoringSector = () => {
  const {
    textFormatting: { toggleSelectedTextFormat, selectedTextFormats },
  } = useMindmap();

  const colorItem = useRef<HTMLDivElement>(null);
  const colorOverlayPanel = useRef<OverlayPanel>(null);

  const highlightItem = useRef<HTMLDivElement>(null);
  const highlightOverlayPanel = useRef<OverlayPanel>(null);

  const toggleColor = (color: TextColors): void => toggleSelectedTextFormat({ type: 'color', color });

  const toggleHighlight = (color: TextColors): void => toggleSelectedTextFormat({ type: 'highlight', color });

  const toggleColorOverlay = (e: React.MouseEvent<HTMLDivElement, MouseEvent>): void => {
    // toggle color overlay
    colorOverlayPanel?.current?.toggle(e);
    // hide hightlight overlay
    highlightOverlayPanel?.current?.hide();
  };

  const toggleHighlightOverlay = (e: React.MouseEvent<HTMLDivElement, MouseEvent>): void => {
    // toggle hightlight overlay
    highlightOverlayPanel?.current?.toggle(e);
    // hide color overlay
    colorOverlayPanel?.current?.hide();
  };

  const selectedTextColor = selectedTextFormats?.color.activeColor;
  let selectedTextHighlight = selectedTextFormats?.highlight.activeHighlight;
  // if the highlight color is white don't use that white for the icon
  selectedTextHighlight =
    selectedTextHighlight && ['var(--surface-0)', 'rgb(239, 243, 248)'].includes(selectedTextHighlight)
      ? undefined
      : selectedTextHighlight;

  return (
    <>
      {/* color (text-color) */}
      <div ref={colorItem} style={{ gridColumn: '1 / 2', gridRow: '1 / 2' }} onClick={toggleColorOverlay}>
        <OverlayPanel
          ref={colorOverlayPanel}
          className="color-overlay-panel first-row-color-overlay-panel"
          appendTo={colorItem.current}
        >
          <ColorPicker onSelected={toggleColor} selectedColor={selectedTextColor} />
        </OverlayPanel>
        <i className="context-menu-icon pi ri-font-color" style={{ color: selectedTextColor }}></i>
      </div>
      {/* highlight (text-background-color) */}
      <div ref={highlightItem} style={{ gridColumn: '1 / 2', gridRow: '2 / 3' }} onClick={toggleHighlightOverlay}>
        <OverlayPanel
          ref={highlightOverlayPanel}
          className="color-overlay-panel second-row-color-overlay-panel"
          appendTo={highlightItem.current}
        >
          <ColorPicker onSelected={toggleHighlight} selectedColor={selectedTextHighlight} />
        </OverlayPanel>
        <i className="context-menu-icon pi ri-mark-pen-fill" style={{ color: selectedTextHighlight }}></i>
      </div>
    </>
  );
};
